module.exports = __webpack_public_path__ + "static/media/comment.c24bbfaa.svg";